import { Seeker } from '../../../firebase/firestore/documents/seeker';
import { FreeFormQuestion, SpecificQuestion } from '../../../firebase/firestore/documents/position';

export type TopCandidateDataType = {
  id?: string;
  education: string;
  fitmatch: string;
  hasApplied: boolean;
  hasBeenRated: boolean;
  hasFlexibleTransportation: boolean;
  questions: {
    freeFormQuestionResponses?: [FreeFormQuestion];
    questionResponses?: [SpecificQuestion];
  };
  seeker: Seeker;
  status?: string;
  withinRange: boolean | string;
  workExperience: number;
  experienceType?: ExperienceType | null;
};

export enum ExperienceType {
  SIGNIFICANT = 'significant',
  SOME = 'some',
  LIMITED = 'limited',
}

export type PaginatedTopCandidateResponse = {
  paging: TopCandidatePagination;
  data: TopCandidateDataType[];
};

export type TopCandidateBodyDataType = {
  communityCandidatesCount: number;
  excludedSeekerIds: string[];
  maxItems: number;
  startFromId: string;
  startFromIndex: number;
  searchType: string;
  // for bookmarked and active
  isSalaryWithinRange?: boolean;
  minimumExperienceInYear?: number;
  // for best_match
  minSalary?: number;
  maxSalary?: number;
  // for all
  hasTransportation?: boolean;
  lastActiveDate?: Date;
  name?: string;
  search?: string;
  filters?: TopCandidateFilters;
  page?: number;
};

export type TopCandidatePagination = {
  total: number;
  startIndex?: number;
  endIndex?: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
};

export type TopCandidateFilters = {
  salaryRange?: { from: number; to: number };
  flexibleTransportation?: boolean;
  lastActivityInDays?: number;
  experienceInYears?: number;
};
